<!-- クレカ情報 -->
<template>
  <div class="row">
    <div class="th cell">決済方法</div>
    <div class="cell">クレジットカード</div>
  </div>
  <div class="row">
    <div class="th cell">カード番号</div>
    <div class="cell">{{ cardInfo.card_no }}</div>
  </div>
  <div class="row">
    <div class="th cell">カード有効期限</div>
    <div class="cell">
      {{ cardInfo.card_exp[2] }}{{ cardInfo.card_exp[3] }}/{{
        cardInfo.card_exp[0]
      }}{{ cardInfo.card_exp[1] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "StoreCardInfo",
  props: {
    cardInfo: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
  padding-right: 14px;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
